import type { ColorModifierValue } from "schemas/generated/fileModifiers";

import React from "react";

import { useOptimisticModifierValue } from "@v2/features/modifiers/hooks/useOptimisticModifierValue";

import ColorSelector from "./ColorSelector";

interface TextColorModifierProps {
  onChange: (modifiers: ColorModifierValue[]) => void;
}

const TextColorModifierComponent: React.FC<TextColorModifierProps> = ({
  onChange,
}) => {
  const currentColor = useOptimisticModifierValue({
    modifierType: { type: "color", value: null },
    extractor: (elementDesignation) => {
      return elementDesignation.element.styleOverrides?.color ?? null;
    },
  });

  const handleColorChange = (color: string | null) => {
    const modifier: ColorModifierValue = {
      type: "color",
      value: color,
    };
    onChange([modifier]);
  };

  return <ColorSelector value={currentColor} onChange={handleColorChange} />;
};

export default TextColorModifierComponent;
